import Rete from 'rete';
import {v4 as uuid} from "uuid";
import {
    NodeFileSearchControl,
    LabelAddButtonControl,
    LabelNumberTextControl,
    SearchControl
} from "../controls";
import {SequenceComponentHelper} from "../extensions/SequenceComponentHelper";
import {DefaultSequenceNode} from "../nodes/DefaultSequenceNode";
import {NodeFileType} from "models/NodeFileType";

export class DefaultSequenceComponent extends Rete.Component {

    static get COMPONENT_NAME() { return "Default Sequence"; };

    // TODO: get names from static global const variable? instead of hardcoded "string"?
    // TODO: globals are duplicated - the same are in SequenceComponent.js
    static get VIDEO_CHILD_COMPONENT_KEY() { return "VideoComponent"; };
    static get NESTED_NODE_TITLE_KEY() { return "nestedNodeTitle"; };

    static get VIDEO_FILE_KEY() { return "videoFile";};
    static get VIDEO_MAPPING_KEY() { return "videoMapping";};
    static get STEREO_MODE_KEY() { return "stereoMode";};
    static get START_FRAME_KEY() { return "startFrame";};
    static get STOP_FRAME_KEY() { return "stopFrame";};


    constructor() {
        super(DefaultSequenceComponent.COMPONENT_NAME);
        this.data.component = DefaultSequenceNode;
        this.props = {}
    }

    builder(node) {
        ///////////////////////////////////////
        /// --- Default Sequence Component (parent) ---
        ///////////////////////////////////////
        if (node.componentId === undefined) {
            node.componentId = uuid();
        }

        ////////////////////////////////////////
        /// --- Nested Components (children) ---
        ///////////////////////////////////////
        const videoUUID = uuid();
        const addVideoButtonControl = new LabelAddButtonControl(
            this.editor,
            `${videoUUID}_${DefaultSequenceComponent.VIDEO_CHILD_COMPONENT_KEY}_${DefaultSequenceComponent.NESTED_NODE_TITLE_KEY}`,
            node,
            false,
            "Video: ",
            () => this.addVideo(node),
            true);

        const {videoId} = SequenceComponentHelper.getDataIds(node.data);

        if (videoId !== null) {
            this.addVideo(node, videoId);
        } else {
            this.addVideo(node);
        }

        addVideoButtonControl.setAddButtonActive(false);

        return node
            .addControl(addVideoButtonControl);
    }

    // could be async
    worker(node, inputs, outputs) {

    }

//region Nested Video
    // todo: create some kind of parent class? for creating nested video, voice answer and other components
    // move to sequence helper?
    // it duplicate code from SequenceComponent.js
    addVideo(node, videoUUID = null) {
        if (videoUUID == null) {
            videoUUID = uuid();
        }

        const videoFileControl = new NodeFileSearchControl(
            this.editor,
            `${videoUUID}_${DefaultSequenceComponent.VIDEO_CHILD_COMPONENT_KEY}_${DefaultSequenceComponent.VIDEO_FILE_KEY}`,
            node,
            NodeFileType.Video,
            false,
            "Video file"
        );

        const videoMappingOptions = [
            { value: 'normal', label: 'normal' },
            { value: '180', label: '180' },
            { value: '360', label: '360' }
        ];
        const videoMappingSearchControl = new SearchControl(
            this.editor,
            `${videoUUID}_${DefaultSequenceComponent.VIDEO_CHILD_COMPONENT_KEY}_${DefaultSequenceComponent.VIDEO_MAPPING_KEY}`,
            node,
            false,
            "Video mapping",
            videoMappingOptions,
            videoMappingOptions[0].value
        );

        const stereoModeOptions = [
            { value: 'none', label: 'none' },
            { value: 'left-right', label: 'left-right' },
            { value: 'top-bottom', label: 'top-bottom' }
        ];
        const stereoModeSearchControl = new SearchControl(
            this.editor,
            `${videoUUID}_${DefaultSequenceComponent.VIDEO_CHILD_COMPONENT_KEY}_${DefaultSequenceComponent.STEREO_MODE_KEY}`,
            node,
            false,
            "Stereo mode",
            stereoModeOptions,
            stereoModeOptions[0].value
        );

        const startTimeControl = new LabelNumberTextControl(
            this.editor,
            `${videoUUID}_${DefaultSequenceComponent.VIDEO_CHILD_COMPONENT_KEY}_${DefaultSequenceComponent.START_FRAME_KEY}`,
            node,
            false,
            "Start frame"
        );

        const stopTimeControl = new LabelNumberTextControl(
            this.editor,
            `${videoUUID}_${DefaultSequenceComponent.VIDEO_CHILD_COMPONENT_KEY}_${DefaultSequenceComponent.STOP_FRAME_KEY}`,
            node,
            false,
            "Stop frame"
        );

        node
            .addControl(videoFileControl)
            .addControl(videoMappingSearchControl)
            .addControl(stereoModeSearchControl)
            .addControl(startTimeControl)
            .addControl(stopTimeControl);

        node.update();
    }
//endregion
}